import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import AppContext from 'context/Context';

const NavbarNavLink = ({ title, route }) => {
  const {
    config: { navbarCollapsed, showBurgerMenu },
    setConfig
  } = useContext(AppContext);

  const handleClick = () => {
    if (navbarCollapsed) {
      setConfig('navbarCollapsed', !navbarCollapsed);
    }
    if (showBurgerMenu) {
      setConfig('showBurgerMenu', !showBurgerMenu);
    }
  };

  const linkClass = classNames('tw-block tw-text-sm tw-font-medium tw-no-underline', {
    'tw-text-[#9da9bb]': !route?.active && !title,
    'tw-text-[#5e6e82] tw-mb-0 tw-font-bold': title,
    'tw-py-1': !title,
    'tw-text-[#748194] hover:tw-text-[#232e3c]': !title && route?.active
  });

  if (title) {
    return (
      <p className={linkClass} onClick={handleClick}>
        {title}
      </p>
    );
  }

  return (
    <Link className={linkClass} to={route?.to} onClick={handleClick}>
      {route.name}
    </Link>
  );
};

NavbarNavLink.propTypes = {
  title: PropTypes.string,
  route: PropTypes.shape({
    name: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
    active: PropTypes.bool
  })
};

export default NavbarNavLink;
